import { render, staticRenderFns } from "./ShortTermBatchApprovalDialog.vue?vue&type=template&id=51557ce7"
import script from "./ShortTermBatchApprovalDialog.vue?vue&type=script&lang=js"
export * from "./ShortTermBatchApprovalDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports